type selectorFunc = (compId: string) => string

type SpecialQAComps = {
	[compType: string]: {
		[childCompType: string]: selectorFunc
	}
}

const gridChildComps = {
	'wysiwyg.viewer.components.Grid.HeadRow': () => 'thead > tr',
	'wysiwyg.viewer.components.Grid.HeadCell': () => 'thead > tr > th',
	'wysiwyg.viewer.components.Grid.Body': () => 'tbody',
	'wysiwyg.viewer.components.Grid.BodyRow': () => 'tbody > tr',
	'wysiwyg.viewer.components.Grid.BodyCell': () => 'tbody > tr > td',
	'wysiwyg.viewer.components.Grid.Pagination': () => '[data-testid="pagination"]',
	'wysiwyg.viewer.components.Grid.PaginationText': () => '[data-testid="pagination-text"]',
	'wysiwyg.viewer.components.Grid.PaginationNextButton': () => '[data-testid="page-next"]',
	'wysiwyg.viewer.components.Grid.PaginationPrevButton': () => '[data-testid="page-prev"]',
	'wysiwyg.viewer.components.Grid.Loader': () => '[data-testid="loader"]',
}

const SlideShowSlideTypes = {
	'wysiwyg.viewer.components.StripContainerSlideShow': {
		'wysiwyg.viewer.components.StripContainerSlideShowSlide': () => '[data-testid="slidesWrapper"] > *',
	},
	'wysiwyg.viewer.components.BoxSlideShow': {
		'wysiwyg.viewer.components.BoxSlideShowSlide': () => '[data-testid="slidesWrapper"] > *',
	},
}

export const childQAComps: SpecialQAComps = {
	...SlideShowSlideTypes,
	'wysiwyg.viewer.components.menus.DropDownMenu': {
		'core.components.MenuButton': (compId) => `nav ul#${compId}itemsContainer > li`,
	},
	'wysiwyg.viewer.components.inputs.RadioGroup': {
		'wysiwyg.viewer.components.inputs.RadioButton': () => `label`,
	},
	'wysiwyg.viewer.components.Grid': gridChildComps,
}

export const mutationQAComps: SpecialQAComps = {
	...SlideShowSlideTypes,
	'wysiwyg.viewer.components.menus.DropDownMenu': {
		'core.components.MenuButton': (compId: string) => `#${compId}dropWrapper li`,
	},
	'wysiwyg.viewer.components.inputs.RadioGroup': {
		'wysiwyg.viewer.components.inputs.RadioButton': () => `label`,
	},
	'wysiwyg.viewer.components.inputs.DatePicker': {
		'wysiwyg.viewer.components.Day': () => 'td',
		dayContent: () => 'td > button',
		dayCaption: () => 'td > button > span',
	},
	'wysiwyg.viewer.components.Grid': gridChildComps,
}
